import React, { useContext } from 'react';
import ClientColorContext from '../ClientColorContext/ClientColorContext';
import Style from '../Style';
export default function ClientColorCss(_ref) {
  var id = _ref.id,
    children = _ref.children;
  var colors = useContext(ClientColorContext);
  if (id) {
    return /*#__PURE__*/React.createElement(Style, {
      id: id
    }, children(colors));
  } else {
    return /*#__PURE__*/React.createElement("style", null, children(colors));
  }
}